import React from 'react'
import PropTypes from 'prop-types'

import { HeaderLeft, HeaderLogo, HeaderRight } from '..'
import './style.scss'

/**
 * HeaderMenu.
 *
 * @returns {div}
 */
export const HeaderMenu = ({ currentProject, currentScenario }) => (
  <div className="header">
    <HeaderLeft currentProject={currentProject} currentScenario={currentScenario} />
    <HeaderLogo />
    <HeaderRight currentProject={currentProject} currentScenario={currentScenario} />
  </div>
)

HeaderMenu.displayName = 'HeaderMenu'

HeaderMenu.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object
}

HeaderMenu.defaultProps = {
  currentProject: null,
  currentScenario: null
}
